import React, { Component } from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link, useHistory } from "react-router-dom";

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  getPartyApi,
  getCubeList,
  getUserByRoleId,
  addAssignCubesFillerToMachinOperators,
} from "api";
import { map } from "lodash";
import moment from "moment/moment";
import { categoriTypes, cubeList } from "components/StaticData";
import { withTranslation } from "react-i18next";

class FillerProcessList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sizePerPage: 10,
      totalSize: 10,
      partyId: "",
      stockList: [],
      partyList: [],
      inwardId: "",
      fillerList: [],
      fillerId: "",
      status: "",
    };
  }

  async componentDidMount() {
    const partyList = await getPartyApi({page:null,limit:null,name:null,partyCode:null});
    if(partyList && partyList.data){
      this.setState({
        partyList: partyList.data.parties,
      });
    }
    
    this.getStockList();
  }

  async getStockList() {
    const stock = await getCubeList({
      page: this.state.page,
      limit: this.state.sizePerPage,
      assignStatus: "P",
    });
    if(stock && stock.data){
      this.setState({
        totalSize: stock.data.count,
        stockList: stock.data.stockFillerInWards.length == 0 ? [
          {
            id: "0",
            jangad: {
              cycle: 0,
              weight: 0,
              pieces: 0,
              createdAt: "0",
              factory: {
                name: "0"
              }
            },
            dataEntryGraderUser: {
              name: "0"
            },
            processId : 0,
            mainJangad: {
              name: "0",
              party: {
                name: "0",
                partyCode:"0"
              },
            },
            stockDataEntryInWard: {
              srNo: 0,
              pieces: 0
            },
            partyName: "0",
            weight: 0,
            pieces: 0,
            cycle: 0,
            createdAt: "",
            updatedAt: "",
            fillerStatus: "P",
            assignGraderToFillerStock: null,
          },
        ] : stock.data.stockFillerInWards,
      });
    }
   
  }

  getFilterStockList() {
    return this.state.stockList.filter(x => {
      if (
        this.state.partyId == "" &&
        this.state.fillerId == "" &&
        this.state.status == ""
      )
        return x;
      else if (
        this.state.partyId == "" &&
        this.state.fillerId == "" &&
        this.state.status == x.fillerStatus
      )
        return x;
      else if (
        this.state.partyId == "" &&
        this.state.fillerId == x.fillerId &&
        this.state.status == ""
      )
        return x;
      else if (
        this.state.partyId == "" &&
        this.state.fillerId == x.fillerId &&
        this.state.status == x.fillerStatus
      )
        return x;
      else if (
        this.state.partyId == "" &&
        this.state.fillerId == "" &&
        this.state.status == ""
      )
        return x;
      else if (
        this.state.partyId == "" &&
        this.state.fillerId == "" &&
        this.state.status == x.fillerStatus
      )
        return x;
      else if (
        this.state.partyId == "" &&
        this.state.fillerId == x.fillerId &&
        this.state.status == ""
      )
        return x;
      else if (
        this.state.partyId == "" &&
        this.state.fillerId == x.fillerId &&
        this.state.status == x.fillerStatus
      )
        return x;
      else if (
        this.state.partyId == x.stock.party.id &&
        this.state.fillerId == "" &&
        this.state.status == ""
      )
        return x;
      else if (
        this.state.partyId == x.stock.party.id &&
        this.state.fillerId == "" &&
        this.state.status == x.fillerStatus
      )
        return x;
      else if (
        this.state.partyId == x.stock.party.id &&
        this.state.fillerId == x.fillerId &&
        this.state.status == ""
      )
        return x;
      else if (
        this.state.partyId == x.stock.party.id &&
        this.state.fillerId == x.fillerId &&
        this.state.status == x.fillerStatus
      )
        return x;
      else if (
        this.state.partyId == x.stock.party.id &&
        this.state.fillerId == "" &&
        this.state.status == ""
      )
        return x;
      else if (
        this.state.partyId == x.stock.party.id &&
        this.state.fillerId == "" &&
        this.state.status == x.fillerStatus
      )
        return x;
      else if (
        this.state.partyId == x.stock.party.id &&
        this.state.fillerId == x.fillerId &&
        this.state.status == ""
      )
        return x;
      else if (
        this.state.partyId == x.stock.party.id &&
        this.state.fillerId == x.fillerId &&
        this.state.status == x.fillerStatus
      )
        return x;
    });
  }

  render() {
    const columns = [
      {
        dataField: "srNo",
        text: "#",
        formatter: (cell, row, index) => {
          return row.stock.id;
        },
      },
      {
        dataField: "id",
        hidden: true,
        text: "Inward ID",
        sort: true,
      },
      {
        dataField: "cubeId",
        text: `${this.props.t("Belt Id")}`,
        sort: true,
      },
      {
        dataField: "partyCode",
        text: `${this.props.t("Party Code")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.stock.partyCode;
        },
      },
      {
        dataField: "weight",
        text:`${this.props.t('Weight')}`,
        sort: true,
      },
      {
        dataField: "pieces",
        text:`${this.props.t('Pieces')}`,
        sort: true,
      },
      {
        dataField: "categoryId",
        text: `${this.props.t('Category')}`,
        sort: true,
        formatter: (cell, row) => {
          return categoriTypes.filter(x => x.value == cell)[0].label;
        },
      },
      {
        dataField: "assignDate",
        text: "Assign Date",
        sort: true,
        formatter: (cell, row) => {
          return moment(row.createdAt).format("DD/MM/YYYY");
        },
      },
    ];

    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      onPageChange: (page, limit) => {
        this.setState({ page: page }, () => this.getStockList());
      },
      sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => {
        return (
          <li key={text} role="presentation" className="dropdown-item">
            <a
              href="#"
              className="text-dark"
              tabIndex="-1"
              role="menuitem"
              data-page={page}
              onMouseDown={e => {
                onSizePerPageChange(page);
                this.setState({ page: 1, sizePerPage: page }, () =>
                  this.getStockList()
                );
              }}
            >
              {text}
            </a>
          </li>
        );
      },
      sizePerPageList: [10, 25, 50, 100],
      page: this.state.page,
      totalSize: this.state.totalSize,
      custom: true,
    };

    const { SearchBar } = Search;

    //meta title
    document.title = "filler flow";

    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={columns}
        data={this.getFilterStockList()}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={columns}
            data={this.getFilterStockList()}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <h3 className="text-black fw-bold text-uppercase">
                      {this.props.t('My Stock List')}
                    </h3>
                    <Row>
                      <Col className="col-12 mt-3">
                        <Card>
                          <CardBody>
                            <div className="d-xxl-flex d-block justify-content-between text-center text-xxl-start">
                              <div className="">
                                <h4 className="text-black fw-bold">
                                  {this.props.t('My Stock List')}
                                </h4>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <label
                                  htmlFor="date"
                                  className="fs-5 fw-bold text-black pe-3"
                                >
                                  {this.props.t('From Date')}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0    "
                                  name="date"
                                />
                                <label
                                  htmlFor="date"
                                  className="fs-5 fw-bold px-0 px-md-3 text-black"
                                >
                                  {this.props.t('To Date')}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0"
                                  name="date"
                                />
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t('Select Party')}
                                    </label>
                                    <select
                                      id="factoryId"
                                      className="officestock-select"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            partyId: e.target.value,
                                          },
                                          () => this.getStockList()
                                        );
                                      }}
                                    >
                                      <option value="">ALL</option>
                                      {this.state.partyList?.map(
                                        (x, index) => (
                                          <option
                                            key={x.id + index}
                                            value={x.id}
                                          >
                                            {x.partyCode}
                                          </option>
                                        )
                                      )}
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between">
                              <div>
                                <div className="pt-3 pt-xxl-0">
                                  <p className="d-inline pe-3 fs-5">{this.props.t('Show')}</p>
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      className=""
                                      {...paginationProps}
                                    />
                                  </div>

                                  <p className="d-inline ps-3 fs-5">{this.props.t('entries')}</p>
                                </div>
                              </div>
                              {/* <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t('Jangad No')}
                                    </label>
                                    <select
                                      id="inwardID"
                                      className="officestock-select"
                                      onChange={e => {
                                        this.setState({
                                          jangadId: e.target.value,
                                        });
                                      }}
                                    >
                                      <option value="">ALL</option>
                                      {this.state.stockList?.map((x, index) => (
                                        <option key={x.id + index} value={x.id}>
                                          {x.id}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                              </div> */}
                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t('Jangad No')}
                                    </label>
                                    <select
                                      id="inwardID"
                                      className="officestock-select"
                                      onChange={e => {
                                        this.setState({
                                          jangadId: e.target.value,
                                        });
                                      }}
                                    >
                                      <option value="">ALL</option>
                                      {this.state.stockList?.map((x, index) => (
                                        <option key={x.id + index} value={x.id}>
                                          {x.name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    remote={true}
                                    keyField={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    onTableChange={() => false}
                                    defaultSorted={defaultSorted}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Col className="inner-custom-pagination mt-4 d-flex justify-content-between">
                              <div className="">
                                <h5>
                                  {this.props.t('Showing')}{" "}
                                  {(this.state.page - 1) *
                                    this.state.sizePerPage +
                                    1}
                                  -{" "}
                                  {this.state.totalSize < this.state.sizePerPage
                                    ? this.state.totalSize
                                    : this.state.sizePerPage *
                                        this.state.page >=
                                      this.state.totalSize
                                    ? this.state.totalSize
                                    : this.state.sizePerPage * this.state.page}{" "}
                                  of {this.state.totalSize}
                                </h5>
                              </div>
                              <div className="ms-auto">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
  }
}
export default withTranslation()(FillerProcessList);
